import { render } from "./ico-video.vue?vue&type=template&id=b8e9ca20&ts=true"
import script from "./ico-video.vue?vue&type=script&lang=ts"
export * from "./ico-video.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__